import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import BasketResetOrder from "./basket-reset-order";
import BasketRow from "./basket-row";

class InMyBasket extends Component {
  constructor(props) {
    super(props);
    this.isOnConfirm = window.location.pathname === '/order/new/confirm';
  }
  basketItem = () => {
    const listItems = Object.keys(this.props.basket).map((curr) => {
      if (this.props.replacements.length > 0) {
        return this.props.replacements.findIndex(
          (m) => m.replacement.id === this.props.basket[curr].product.id
        ) > -1 ? (
          <Row
            key={"product$" + this.props.basket[curr].product.id}
            className="basket-replacement"
          >
            <Col xs={12} className="basket-replacement-header">
              <i className="fa fa-exchange"></i> Replacement product
            </Col>
            <Col xs={12} className="basket-replacement-body">
              <BasketRow
                id={this.props.basket[curr].product.id}
                isOnConfirm={this.isOnConfirm}
              />
            </Col>
          </Row>
        ) : (
          <BasketRow
            key={"product$" + this.props.basket[curr].product.id}
            id={this.props.basket[curr].product.id}
            isOnConfirm={this.isOnConfirm}
          />
        );
      } else {
        return (
          <BasketRow
            key={"product$" + this.props.basket[curr].product.id}
            id={this.props.basket[curr].product.id}
            isOnConfirm={this.isOnConfirm}
          />
        );
      }
    });
    return listItems;
  };
  render() {
    return (
      <div className="in-my-basket">
        <Row>
          <Col sm={6} xs={8}>
            <div className="title h3">IN My basket</div>
          </Col>
          <Col sm={6} xs={4}>
            <BasketResetOrder value="Empty Basket" />
          </Col>
          <Col xs={12}>
            {Object.keys(this.props.basket).length === 0 && (
              <div className="h2">Your basket is empty</div>
            )}
            <div className="basket-body">{this.basketItem()}</div>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    basket: state.orders.new.basket.line_items,
    replacements: state.orders.new.basket.replacements,
  };
};
export default connect(mapStateToProps)(InMyBasket);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/in-my-basket.jsx